// Strip TTS audio direction tags like [happy], [Italian female accent], [pauses]
// AND markdown links like [Booking page](https://...) from agent messages
// before rendering in the bespoke widget transcript. Both categories use
// square brackets but for different reasons — neither belongs in the visible
// chat bubble:
//
//   - Audio tags are voice-direction hints the TTS engine interprets as
//     emotional delivery. They should never appear as text.
//   - Markdown links embedded in farewell templates get surfaced separately
//     as clickable gold pills via the open_tracking_link client tool. If
//     we let the raw "[Booking page](https://...)" string through, only
//     the bracketed part gets stripped and the user sees the bare URL
//     "(https://very-long-url...)" in the bubble.
//
// Order matters: strip markdown links FIRST (pattern `[text](url)`), then
// strip any remaining standalone `[tags]`. Otherwise the tag stripper eats
// the `[text]` half and leaves `(url)` orphaned.
export function stripAudioDirectionTags(text: string): string {
  if (!text) return '';
  return text
    .replace(/\[[^\]]+\]\s*\([^)]+\)/g, '')
    .replace(/\[[^\]]+\]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}
